module.exports = __webpack_public_path__ + "img/20201129_224006.cafa7556.jpg";